import { appAssets } from "../config/assets";

export type StandingRow = {
    rank: number;
    team: string;
    logo: string;
    played: number;
    wins: number;
    draws: number;
    losses: number;
    goalsFor: number;
    goalsAgainst: number;
    goalDiff: number;
    points: number;
};

export const standingsGroupA: StandingRow[] = [
    {
        rank: 1,
        team: "Cap Vert",
        logo: appAssets.teams.capvert,
        played: 7,
        wins: 6,
        draws: 1,
        losses: 0,
        goalsFor: 22,
        goalsAgainst: 4,
        goalDiff: 18,
        points: 19,
    },
    {
        rank: 2,
        team: "Camerlux",
        logo: appAssets.teams.camerlux,
        played: 7,
        wins: 4,
        draws: 0,
        losses: 3,
        goalsFor: 21,
        goalsAgainst: 14,
        goalDiff: 7,
        points: 12,
    },
    {
        rank: 3,
        team: "Lions Ind.",
        logo: appAssets.teams.lions,
        played: 7,
        wins: 3,
        draws: 0,
        losses: 4,
        goalsFor: 16,
        goalsAgainst: 10,
        goalDiff: 6,
        points: 9,
    },
    {
        rank: 4,
        team: "Hespérange",
        logo: appAssets.teams.hesper,
        played: 7,
        wins: 0,
        draws: 0,
        losses: 7,
        goalsFor: 1,
        goalsAgainst: 41,
        goalDiff: -40,
        points: 0,
    },
];

export const standingsGroupB: StandingRow[] = [
    {
        rank: 1,
        team: "Thionville",
        logo: appAssets.teams.fpm237,
        played: 8,
        wins: 6,
        draws: 0,
        losses: 2,
        goalsFor: 28,
        goalsAgainst: 20,
        goalDiff: 8,
        points: 18,
    },
    {
        rank: 2,
        team: "Sénégal",
        logo: appAssets.teams.senegal,
        played: 8,
        wins: 4,
        draws: 2,
        losses: 2,
        goalsFor: 21,
        goalsAgainst: 12,
        goalDiff: 9,
        points: 14,
    },
    {
        rank: 3,
        team: "Guinée",
        logo: appAssets.teams.guinee,
        played: 8,
        wins: 4,
        draws: 2,
        losses: 2,
        goalsFor: 24,
        goalsAgainst: 19,
        goalDiff: 5,
        points: 14,
    },
    {
        rank: 4,
        team: "Gambie",
        logo: appAssets.teams.gambie,
        played: 8,
        wins: 3,
        draws: 1,
        losses: 4,
        goalsFor: 16,
        goalsAgainst: 18,
        goalDiff: -2,
        points: 10,
    },
    {
        rank: 5,
        team: "Soudan",
        logo: appAssets.teams.soudan,
        played: 8,
        wins: 0,
        draws: 1,
        losses: 7,
        goalsFor: 8,
        goalsAgainst: 28,
        goalDiff: -20,
        points: 1,
    },
];

export const groupANote =
    "L’équipe de Diekirch a été disqualifiée en cours de saison. Les résultats des matchs déjà joués ont été maintenus conformément au règlement et au principe d’équité sportive.";